import React, { useState } from "react";
import {
  Container,
  Icon,
  TitleContainer,
  Title,
  BottomContainer,
  HorizontalLine,
} from "./styled.components";
import OnGoingPNG from "../../../assets/images/onGoing.png";
import CompletedPNG from "../../../assets/images/completed.png";
import Seminars from "./seminars";
import Events from "./events";
const heading = [
  {
    id: "1",
    title: "Events",
    icon: OnGoingPNG,
  },
  {
    id: "2",
    title: "Seminars",
    icon: CompletedPNG,
  },
];
const Tab = ({ data }) => {
  console.log(data, "index");
  const [active, setActive] = useState(heading[0].id);
  let _events = [];
  let seminars = [];

  const getEvents = data.events?.map((event_) => {
    if (event_.type === "event") {
      _events.push(event_);
    }
  });

  const getseminars = data.events?.map((seminar_) => {
    if (seminar_.type === "seminar") {
      seminars.push(seminar_);
    }
  });

  const handleClick = () => {
    setActive((e) => !e);
  };
  return (
    <>
      <Container>
        <TitleContainer>
          <Icon src={heading[0].icon} />
          <Title active={active} onClick={handleClick} key={heading[0].id}>
            {heading[0].title}
          </Title>
        </TitleContainer>
        <TitleContainer>
          <Icon src={heading[1].icon} />
          <Title active={!active} onClick={handleClick} key={heading[1].id}>
            {heading[1].title}
          </Title>
        </TitleContainer>
        <BottomContainer></BottomContainer>
      </Container>
      <HorizontalLine />
      {active && data?.events?.length > 0 ? (
        <Events events={_events} />
      ) : (
        <Seminars seminars={seminars} />
      )}
    </>
  );
};

export default Tab;
